import React, { FC, useEffect, useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { Input } from '@cokitchen/cokitchen-components';

type AddressInputProps = {
  address: string;
  setAddress: (value: string) => void;
  setLatLng: (value: { lat: string; lng: string }) => void;
  label?: string;
  placeholder?: string;
};

const AddressInput: FC<AddressInputProps> = ({
  address,
  setAddress,
  setLatLng,
  label,
  placeholder
}) => {
  const [selectedPlaceId, setSelectedPlaceId] = useState('');

  useEffect(() => {
    getLatLng();
  }, [selectedPlaceId]);

  const getLatLng = async () => {
    const geocoder = new google.maps.Geocoder();
    const data = await geocoder.geocode({ placeId: selectedPlaceId });
    const result = data.results[0].geometry;
    setLatLng({ lat: String(result.location.lat()), lng: String(result.location.lng()) });
  };

  const handleChange = (value: string) => {
    setAddress(value);
  };

  const handleProps = (data: any, placeId: string) => {
    const res = {
      ...data,
      onClick: () => {
        data.onClick();
        setSelectedPlaceId(placeId);
      }
    };
    return res;
  };

  const searchOptions = {
    componentRestrictions: { country: ['ng'] }
  };
  return (
    <>
      <PlacesAutocomplete
        value={address}
        debounce={600}
        onChange={setAddress}
        onSelect={handleChange}
        searchOptions={searchOptions}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className=''>
            <Input
              small
              label={label}
              placeholder={placeholder}
              {...getInputProps({})}
              type={'search'}
            />
            <div className={`bg-shadow ${suggestions.length && 'p-2'}`}>
              {loading && <div className='pl-3'>Loading...</div>}
              {suggestions
                .filter((suggestion) => suggestion.placeId)
                .map((suggestion, i) => {
                  const className = `${suggestion.active ? 'px-3 py-2' : 'px-3 py-2'}`;
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? {
                        backgroundColor: '#FEE7EA',
                        transition: 'all .3s',
                        cursor: 'pointer'
                      }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };

                  return (
                    <div
                      {...handleProps(
                        getSuggestionItemProps(suggestion, {
                          className,
                          style
                        }),
                        suggestion.placeId
                      )}
                      key={i}>
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </>
  );
};

export default AddressInput;
